"use client";

import { SecondaryButton } from "../buttons/SecondaryButton";
import { useEffect, useState } from "react";

interface OurClubIntroProps {
  carouselImages: Array<{
    id: number;
    url: string;
    alt: string;
  }>;
}

export function OurClubIntro({ carouselImages }: OurClubIntroProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (carouselImages.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselImages.length);
    }, 3000); // 3 secondes
    return () => clearInterval(interval);
  }, [carouselImages]);

  return (
    <div
      className="flex flex-col lg:flex-row items-start gap-36 ph:gap-48 md:gap-60 lg:gap-72 w-full min-h-[400px]"
      id="notre-club"
    >
      {/* Bloc images */}
      <div className="flex items-center justify-center w-full lg:w-1/2 overflow-hidden h-[459px]">
        <div
          className="flex transition-transform duration-700 ease-in-out h-full w-full"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {carouselImages.map((img) => (
            <div
              key={img.id}
              className="w-full h-full flex-shrink-0 bg-center bg-cover"
              style={{ backgroundImage: `url(${img.url})` }}
              role="img"
              aria-label={img.alt}
            />
          ))}
        </div>
      </div>

      {/* Bloc texte */}
      <div className="flex flex-col justify-center items-start gap-6 w-full lg:w-1/2 pt-4">
        <h2 className="text-3xl md:text-5xl font-bold font-switzer text-accent">
          Notre club
        </h2>
        <div className="flex flex-col gap-4">
          <p className="text-sm md:text-base text-left  font-switzer text-accent/75">
            Présent sur quatre sites à Beauvais et Allonne, le TCAB offre des
            terrains adaptés à tous : résine, couverts ou extérieurs. Un cadre
            idéal pour jouer, progresser et partager sa passion du tennis.
          </p>
          <p className="text-sm md:text-base text-left font-switzer text-accent/75">
            Club ouvert et convivial, nous accueillons aussi bien les débutants
            que les compétiteurs. Ici, chacun trouve sa place, entre esprit
            sportif et moments de convivialité.
          </p>
        </div>
        <SecondaryButton text="Contactez-nous" navigateTo="/#contact" />
      </div>
    </div>
  );
}
